import * as React from "react";
import { IconButton, Menu, MenuItem } from "@material-ui/core";
import { MoreVert } from "@material-ui/icons";
import { DropdownProps } from "src/utils";

const Dropdown: React.FC<DropdownProps> = ({ options }) => {
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);

  const hayOpciones = options.length > 0;

  const handleDropdownClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleOptionClick = (action: () => void) => {
    action();
    close();
  };

  const close = () => {
    setAnchorEl(null);
  };

  const buttons = (options || []).map((option, idx) => (
    <MenuItem key={idx} onClick={() => handleOptionClick(option.action)}>
      {option.text}
    </MenuItem>
  ));

  return (
    <div className="dropdown">
      {hayOpciones && (
        <IconButton
          aria-label="more"
          id="long-button"
          aria-expanded={open ? "true" : undefined}
          aria-haspopup="true"
          onClick={handleDropdownClick}
        >
          <MoreVert />
        </IconButton>
      )}

      <Menu
        className="dropdown-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={close}
      >
        {buttons}
      </Menu>
    </div>
  );
};

export default Dropdown;
